// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1iq_p","consentsList":"PatientConsents_consentsList__1jPqJ","consentsListEmpty":"PatientConsents_consentsListEmpty__2z60l"};